import { render } from "./MuroUserHistory.vue?vue&type=template&id=1ac7cb98&scoped=true"
import script from "./MuroUserHistory.vue?vue&type=script&lang=js"
export * from "./MuroUserHistory.vue?vue&type=script&lang=js"

import "./MuroUserHistory.vue?vue&type=style&index=0&id=1ac7cb98&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac7cb98"]])

export default __exports__